module.exports = __webpack_public_path__ + "31636e4de146faefa416fa47d6fe61fc.svg";